import Filter from './Filter'

import { useState } from 'react'

import cx from 'classnames'

import type { FC } from 'react'
import { usePreferredMarketLocalStorage } from '../../hooks/use-preferred-market'
import { MARKET_OPTIONS } from '../../utils/markets'

type MarketFilterProps = {
  market: string
  onDoneButtonClick(market: string): void
}

const marketNameByHandle = Object.fromEntries(
  MARKET_OPTIONS.map((market) => [market.value, market.label])
)

export const MarketFilter: FC<MarketFilterProps> = (props) => {
  const [selectedMarket, setSelectedMarket] = useState(props.market)
  const [, setPreferredMarket] = usePreferredMarketLocalStorage()

  const onClose = () => {
    props.onDoneButtonClick(selectedMarket)
  }

  const onClear = () => {
    setSelectedMarket(props.market)
  }

  return (
    <Filter
      heading="Market"
      tooltip="The metro-area where you are looking for a home."
      buttonText={marketNameByHandle[props.market]}
      onOpenChange={(open) => (!open ? onClose() : null)}
      onClear={onClear}
      isActive={!!props.market}
    >
      <div className="flex flex-col items-start">
        {MARKET_OPTIONS.map((marketOption) => (
          <button
            key={marketOption.value}
            type="button"
            aria-pressed={marketOption.value === selectedMarket}
            onClick={() => {
              setSelectedMarket(marketOption.value)
              setPreferredMarket(marketOption.value)
            }}
          >
            <p
              className={cx({
                'font-semibold text-teal-3 hover:text-teal-4':
                  marketOption.value === selectedMarket,
              })}
            >
              {marketOption.label}
            </p>
          </button>
        ))}
      </div>
    </Filter>
  )
}
